import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "../../shared/types/domain";

interface SignInScreenProps {
  hasAnonData: boolean;
  authBusy: boolean;
  authEmail: string;
  authPassword: string;
  authError: string | null;
  resetSent: boolean;
  language: string;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onGoogleClick: () => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onForgotPassword: () => void;
  onLanguageChange: (lang: string) => void;
  onCancel: () => void;
}

export function SignInScreen({
  hasAnonData, authBusy, authEmail, authPassword, authError, resetSent, language,
  onEmailChange, onPasswordChange, onGoogleClick, onSubmit, onForgotPassword, onLanguageChange, onCancel,
}: SignInScreenProps) {
  const { t } = useTranslation();

  return (
    <main className="screen">
      <section className="panel auth-panel">
        <h1 className="auth-emoji">👶</h1>
        <h2 className="auth-title">{t("auth.signInTitle")}</h2>
        <p className="auth-subtitle">{t("auth.signInSubtitle")}</p>
        {hasAnonData && <p className="auth-error">{t("auth.signInReplaceWarning")}</p>}

        <button className="google-btn" onClick={onGoogleClick} disabled={authBusy}>
          {t("auth.signInGoogle")}
        </button>

        <div className="auth-divider"><span>{t("auth.orDivider")}</span></div>

        <form className="auth-form" onSubmit={onSubmit}>
          <input
            type="email"
            placeholder={t("auth.email")}
            value={authEmail}
            onChange={e => onEmailChange(e.target.value)}
            required
            autoComplete="email"
          />
          <input
            type="password"
            placeholder={t("auth.password")}
            value={authPassword}
            onChange={e => onPasswordChange(e.target.value)}
            required
            autoComplete="current-password"
          />
          {authError && <p className="auth-error">{authError}</p>}
          {resetSent && <p className="auth-reset-sent">{t("auth.resetSent")}</p>}
          <button type="submit" className="primary-btn" disabled={authBusy}>
            {authBusy ? t("common.loading") : t("auth.signIn")}
          </button>
        </form>

        <button type="button" className="auth-link-btn" onClick={onForgotPassword}>
          {t("auth.forgotPassword")}
        </button>

        <button type="button" className="auth-link-btn auth-toggle-btn" onClick={onCancel}>
          {t("common.cancel")}
        </button>

        <div className="auth-lang-row">
          <label className="auth-lang-label" htmlFor="signin-lang-select">{t("auth.languageLabel")}</label>
          <select
            id="signin-lang-select"
            className="auth-lang-select"
            value={language}
            onChange={e => onLanguageChange(e.target.value)}
          >
            {SUPPORTED_LANGUAGES.map(l => (
              <option key={l.code} value={l.code}>{l.label}</option>
            ))}
          </select>
        </div>

        <a href="/about/" className="about-link-btn" style={{ display: 'block', textAlign: 'center', marginTop: '0.25rem' }}>
          {t("auth.whatIsBabyLog")}
        </a>
        <a href="/blog/" className="about-link-btn" style={{ display: 'block', textAlign: 'center', marginTop: '0.25rem' }}>
          {t("auth.readBlog")}
        </a>
      </section>
    </main>
  );
}
